export var spacingToPixels = function (s) {
    return ({
        none: 0,
        xxs: 1,
        xs: 2,
        s: 3,
        m: 5,
        l: 8,
        xl: 12,
        xxl: 24
    }[s]);
};
